import { Checkbox as MuiCheckbox } from "@mui/material";
import { CheckboxProps } from "@mui/material";
import React from "react";

const Checkbox = (props: CheckboxProps) => {
  return (
    <MuiCheckbox
      {...props}
      color={props.color === "default" ? "primary" : props.color ?? "error"}
    />
  );
};

export default Checkbox;
